export const BASE_URL = process.env.REACT_APP_BASE_URL || "";
export const BASE_HISTORY_URL = process.env.REACT_APP_BASE_HISTORY_URL || "";
export const PUBLIC_URL = process.env.PUBLIC_URL || "";
export const USER_ID = "chat_user_id";
export const SESSION_ID = "chat_session_id";
export const USER_DATA = "chat_user_data";

export type LocalMessage = {
  is_user: boolean;
  message: string;
};
